export default {
    telRule: /^1[3|4|5|6|7|8|9]\d{9}$/,
    passwordRule:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,18}$/
};
